<template>
  <a-menu
    v-model:openKeys='openKeys'
    mode='inline'
    :theme='theme'
    v-model:selectedKeys='selectedKeys'
    @click='onSelectChange'
    @openChange='onOpenChange'
  >
    <template v-for='(item) of menu'>
      <sub-menu 
        v-if="!item.hidden&&item.children && item.children.length > 0 && item.children.length-item.children.filter(v=>v.hidden).length>0&&( 
        !item.children.children || item.children.children.length-item.children.children.filter(v=>v.hidden).length>0)" 
        :key='item.url' 
        :menusKey='item.url'
        :item='item'
      ></sub-menu>
      <menu-item v-else-if="!item.hidden" :key='item.url' :menusKey='item.url'  :item='item'></menu-item>
    </template>
  </a-menu>
</template>
<script>
import {clearPageState} from '../utils/pageState'
import MenuItem from './MenuItem.vue'
import SubMenu from './SubMenu.vue'
// const getOpenKeys = string => { // 旧
//     let newStr = '',
//         newArr = [],
//         arr = string.split('/').map(i => '/' + i)
//     for (let i = 1; i < arr.length - 1; i++) {
//         newStr += arr[i]
//         newArr.push(newStr)
//     }
//     console.log(newArr)
//     return newArr
// }
const getOpenKeys = (string,arr) => { // 新
    let newStr = '',newArr = []
    // 整理 arr 过滤 有二级菜单的数组 
    var filterArr= JSON.parse(JSON.stringify(arr.filter(v=>v.children&&v.children.length?(v.children.filter(val=>!val.hidden).length>=1?v:false):false)))
    // console.log(filterArr)
    if(arr.length < 5){ //小于等于5的默认展开导航
      arr.forEach(i=>{
        newArr.push(i.url)
      })
    }else{
      var arrs = string.split('/').map(i => '/' + i)
      for (let i = 1; i < arrs.length - 1; i++) {
          newStr += arrs[i]
          newArr.push(newStr)
      }
    }
    // console.log(newArr,'菜单')
    return newArr
}
const getPathName = (pathname, menuTree,parentPath) => {
    if(!menuTree)return
    for(let i = 0; i < menuTree.length; i++){
        //路径包含
        if(pathname.search(menuTree[i].url) === 0){
            //路径相等
            if(pathname === menuTree[i].url){
                //隐藏菜单去父路径
                if(menuTree[i].hidden){
                    return parentPath;
                }else {
                    return menuTree[i].url
                }
            } else if (menuTree[i].children && menuTree[i].children.length>0) {
                let str = getPathName(pathname, menuTree[i].children ,menuTree[i].url);
                if(str !== ''){
                    return str;
                }
            }
        }
    }
    return ''
}
export default {
  name: 'SliderMenu',
  components:{
    MenuItem,
    SubMenu
  },
  props: {
    menuToggle: {
      required: true,
      type: Boolean
    },
    theme: String,
    menu: {
      required: true,
      type: Array
    }
  },
  data(){
    return {
      openKeys:[],
      selectedKeys:[],
    }
  },
  mounted() {
    // console.log(this.menu)
    this.openKeys = getOpenKeys(this.$route.path,this.menu);
    this.selectedKeys = [getPathName(this.$route.path, this.menu)];
  },
  watch:{
    menuToggle(newVal) {
      // console.log(newVal)
      if (newVal) {
        this.openKeys = [];
      } else {
        this.openKeys = getOpenKeys(this.$route.path,this.menu);
        this.selectedKeys = [getPathName(this.$route.path, this.menu)];
      }
    },
    '$route'(newVal){
      this.openKeys = getOpenKeys(this.$route.path,this.menu);
      this.selectedKeys = [getPathName(this.$route.path, this.menu)];
    },
    'menu'(newVal){
      this.selectedKeys = [getPathName(this.$route.path, newVal)];
    }
  },
  methods: {
    onOpenChange(v) {
      // console.log(v)
      if (v.length === 0 || v.length === 1) {
          this.openKeys = v;
          return void 0;
      }
      const latestOpenKey = v[v.length - 1]
      // 这里与定义的路由规则有关
      if (latestOpenKey.includes(v[0])) {
          this.openKeys = v;
      } else {
          this.openKeys = [latestOpenKey];
      }
    },
    onSelectChange(e){
      // console.log(e)
      this.openKeys = getOpenKeys(this.$route.path,this.menu);
    }
  }
}
</script>